import pdfMake from "pdfmake/build/pdfmake";
import loadFonts from "../pdf/fonts";

loadFonts().then((fonts) => {
  pdfMake.vfs = { ...fonts };
  pdfMake.fonts = {
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Medium.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-MediumItalic.ttf",
    },
    "Roboto Mono": {
      normal: "RobotoMono-Regular.ttf",
      bold: "RobotoMono-Bold.ttf",
    },
  };
});

export default pdfMake;
